import React from "react";
import Text from "@/components/ui/text";
import IconContainer from "@/components/ui/icon-container";
import { Bullet } from "@dreamhub/designsystem/icons";
import { cn } from "@/utils/utils";
import { simpleDate, toLocalDate } from "@/utils/datetime";
import MeetingPrepEmptyState from "@/components/global/Chat/components/meetingPrep/components/MeetingPrepEmptyState";
import { MeetingPrepNewsItem } from "@/entities/meetingPrep/types";

const RecentNewsTab: React.FC<{ recentNews: MeetingPrepNewsItem[] }> = ({
  recentNews
}) => {
  if (recentNews.length === 0) {
    return <MeetingPrepEmptyState tab="recentNews" />;
  }

  return (
    <div className="flex flex-col py-4">
      {recentNews.map((item, index) => {
        const isLast = index === recentNews.length - 1;
        return (
          <div key={`${item.date}-${index}`} className="flex gap-3 px-4">
            <div className="flex flex-col items-center">
              <IconContainer size="xs" color="secondary" className="mt-1">
                <Bullet />
              </IconContainer>
              {!isLast && (
                <div className="w-px flex-1 bg-border-border1 my-1" />
              )}
            </div>
            <div
              className={cn("flex flex-col gap-1 min-w-0", !isLast && "pb-4")}
            >
              <Text variant="bodyTertiary">
                {simpleDate(
                  toLocalDate(item.date),
                  "short",
                  false,
                  false,
                  true
                )}
              </Text>
              <Text variant="body" className="whitespace-pre-wrap break-words">
                {item.summary}
              </Text>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RecentNewsTab;
